// Replace these with your actual EmailJS credentials
// Sign up free at https://www.emailjs.com
export const EJS_PUBLIC_KEY  = 'PI_Xg_ohlRj06X9m0';
export const EJS_SERVICE_ID  = 'service_ru19f5h';
export const EJS_TEMPLATE_ID = 'template_omvvhwl';